import { APP_INITIALIZER, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard, T4coreModule, UIService } from 't4core';
import { T4CommonModule } from '../../t4common/t4common';
import { HomeComponent } from './views/Home/home.component';
import { UploadObjectDialog } from './dialogs/UploadObject/UploadObject';
import { UpcomingObjectsComponent } from './components/UpcomingObjects/UpcomingObjects.component';
import { FailedInvoicesComponent } from './components/FailedInvoices/FailedInvoices.component';
import { PendingChangesGuard } from '../../t4common/guards/pending-changes.guard';


@NgModule({
  declarations: [
    HomeComponent,
    UpcomingObjectsComponent,
    UploadObjectDialog,
    FailedInvoicesComponent,
  ],
  imports: [
    T4CommonModule,
    T4coreModule,
    RouterModule.forChild([
      {
        path: 'CustomerService',
        canActivate: [AuthGuard],
        data: { index: 2, title: "Customer Service", toolTip: "Customer service map", experimental: true, roles: ['Backoffice'], icon: 'support_agent' },
        children: [
          { path: '', redirectTo: 'Map', pathMatch: 'full' },
          {
            path: "Map",
            canActivate: [AuthGuard],
            canDeactivate: [PendingChangesGuard],
            component: HomeComponent,
            data: { title: "Map", toolTip: "Map search", roles: ['Backoffice'], icon: 'bar_chart' }
          },
          {
            path: "UpcomingObjects",
            canActivate: [AuthGuard],
            component: UpcomingObjectsComponent,
            data: { title: "Upcoming objects", toolTip: "Upcoming objects", roles: ['Backoffice'], icon: 'bar_chart' }
          },
          {
            path: "FailedInvoices",
            canActivate: [AuthGuard],
            component: FailedInvoicesComponent,
            data: { title: "Failed invoices", toolTip: "Upcoming objects", roles: ['Backoffice'], icon: 'bar_chart' }
          }
        ]
      },
    ])
  ],
  providers: [T4CommonModule, { provide: APP_INITIALIZER, useFactory: initModule, deps: [UIService], multi: true }]
})
export class CustomerServiceModule { }

// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({
      dialogs: [

      ]
    });
  };
}

